import React, { useEffect, useRef, useState } from "react";
import i18n from "i18next";
import { useTheme } from "../../context/ThemeContext";
import { useNavigate } from "react-router-dom";
import { useClient } from "../../context/ClientContext";
import AuthService from "../../services/AuthService";
import { useNotification } from "../../context/NotificationContext";
import { capitalize } from "../../shared/utils/stringUtils";

const Topbar: React.FC = () => {
  const { theme, toggleTheme } = useTheme(); //TODO: Hapa tunatumia global theme state
  const [activeLang, setActiveLang] = useState("en");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const notification = useNotification();
  const [profile, setProfile] = useState({
    userName: "",
    userEmail: "",
  });
  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };
  const profileMenu = [{ icon: "logout", name: "Logout" }];

  const client = useClient("AUTH_SERVICE");
  const authService = new AuthService(client, notification);

  useEffect(() => {
    const savedLang = localStorage.getItem("lang") || i18n.language || "en";
    setActiveLang(savedLang);
    profileDetails();
    i18n.changeLanguage(savedLang);
  }, []);

  const switchLanguage = () => {
    const newLang = activeLang === "en" ? "sw" : "en";
    setActiveLang(newLang);
    i18n.changeLanguage(newLang);
    localStorage.setItem("lang", newLang);
  };
  const profileDetails = () => {
    setProfile({
      userName: capitalize(localStorage.getItem("userName") ?? "", "title"),
      userEmail: localStorage.getItem("userEmail") ?? "",
    });
  };
  const profileAction = (menuItem: { name: string }) => {
    switch (menuItem.name) {
      case "Logout": {
        authService.logout();
        break;
      }
      default: {
        console.log("default");
      }
    }
  };
  const handleClick = () => {
    navigate("/");
  };
  return (
    <div
      className={`py-2 px-6 flex items-center justify-between ${
        theme === "night"
          ? "bg-gradient-to-r from-gray-700 to-gray-600 text-gray-50"
          : "bg-gradient-to-r from-primary-100 to-primary-50 text-black"
      }`}
    >
      <div
        className="flex items-center gap-4 hover:bg-primary-100/60 cursor-pointer p-2 rounded-xl"
        onClick={handleClick}
      >
        <div className="flex flex-col border-l-2 border-primary-700 pl-4">
          <span
            className={`font-bold text-xl ${
              theme === "night" ? "text-primary-700" : "text-primary-900"
            }`}
          >
            SERCEA
          </span>
          <span
            className={`font-bold text-xs ${
              theme === "night" ? "text-primary-500" : "text-primary-700"
            } hidden sm:inline`}
          >
            Strengthening Ethics and Responsible Conduct of Clinical Trial in
            East and Sub-Sahara Africa
          </span>
        </div>
      </div>

      <div className="flex items-center justify-end gap-6">
        <button
          onClick={toggleTheme}
          className={`w-10 h-10 flex items-center justify-center rounded-full ${
            theme === "light" ? "bg-primary-200" : "bg-gray-700"
          }`}
        >
          <span
            className={`material-icons ${
              theme === "night" ? "text-primary-500" : "text-gray-700"
            }`}
          >
            {theme === "night" ? "light_mode" : "dark_mode"}
          </span>
        </button>

        <button
          onClick={switchLanguage}
          className={`w-10 h-10 flex items-center justify-center relative rounded-full ${
            theme === "light" ? "bg-primary-200" : "bg-gray-700"
          }`}
        >
          <span
            className={`material-icons ${
              theme === "night" ? "text-primary-500" : "text-gray-700"
            }`}
          >
            translate
          </span>
          <span
            className={`absolute bottom-0 right-0 w-2.5 h-2.5 text-xs ${
              theme === "night" ? "text-primary-500" : "text-gray-700"
            }`}
          >
            {activeLang}
          </span>
        </button>
        <div
          className="flex items-center gap-3 cursor-pointer relative"
          onClick={toggleMenu}
        >
          <div
            className="flex items-center justify-center rounded-full"
            onClick={toggleMenu}
          ></div>
          <div className="hidden sm:flex flex-col justify-around">
            <span
              className={`font-bold text-sm ${
                theme === "night" ? "text-primary-500" : "text-gray-700"
              }`}
            >
              {profile.userName}
            </span>
            <span
              className={`text-xs ${
                theme === "night" ? "text-primary-500" : "text-gray-700"
              }`}
            >
              {profile.userEmail}
            </span>
          </div>
          <div className="flex-col justify-around sm:hidden">
            <span
              className={`material-icons ${
                theme === "night" ? "text-primary-500" : "text-gray-700"
              }`}
            >
              menu
            </span>
          </div>
          <span
            className={`material-icons ${
              theme === "night" ? "text-primary-500" : "text-gray-700"
            }
                             hidden sm:inline`}
          >
            arrow_drop_down
          </span>
          {isMenuOpen && (
            <div
              className={`absolute top-full right-0 mt-2 z-50 w-56 rounded-3xl shadow-md overflow-hidden
                  ${theme === "night" ? "bg-gray-500" : "bg-primary-300"}
                `}
            >
              <div
                onClick={() => profileAction({ name: "Logout" })}
                className={`px-4 py-3 flex items-center gap-3 border-b last:border-b-0 cursor-pointer
                    ${
                      theme === "night"
                        ? "text-primary-500 hover:bg-gray-700"
                        : "text-gray-700 hover:bg-primary-200"
                    }
                  `}
              >
                <span
                  className={`material-icons ${
                    theme === "night" ? "text-primary-500" : "text-gray-700"
                  }`}
                >
                  logout
                </span>
                <span className="font-medium">Logout</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
